/** Look of the public scoreboard: podium colours for the top 3 and the shots progress bar. */

export type PodiumTier = 'gold' | 'silver' | 'bronze';

/** Gold / silver / bronze for ranks 1-3 (tied shooters share the rank, so share the colour). */
export function podiumTier(rank: number): PodiumTier | null {
  if (rank === 1) return 'gold';
  if (rank === 2) return 'silver';
  if (rank === 3) return 'bronze';
  return null;
}

/** Share of planned shots fired, 0-100, for the thin bar under "n/15". */
export function shotProgress(fired: number | undefined, planned: number | undefined): number {
  if (!planned || planned <= 0) return 0;
  const share = ((fired ?? 0) / planned) * 100;
  return Math.max(0, Math.min(100, Math.round(share)));
}

/** What makes a row flash: its rank, total, shots fired or latest shot changed. */
export function rowSignature(row: {
  rank: number;
  totalDisplay: string;
  shotsFired?: number;
  latest?: { pointsDisplay: string; label: string } | null;
}): string {
  return `${row.rank}|${row.totalDisplay}|${row.shotsFired ?? ''}|${row.latest?.pointsDisplay ?? ''}|${row.latest?.label ?? ''}`;
}
